import { sleep } from './facial_verification_field_shared';

export function perform_countdown(state) {
  const values = [3, 2, 1];
  const countdown = values.reduce((promise, value) => {
    return promise.then(() => {
      state.countdown.value = value;
      return sleep(700);
    });
  }, Promise.resolve());

  return countdown.then(() => {
    state.countdown.value = 0;
  });
}

function create_capture_sampler(state, challenge, capture_started_at, capture_frame, pending, capture_errors) {
  const sampler = window.setInterval(() => {
    const capture_task = capture_frame(state, challenge.code, capture_started_at)
      .then((frame) => {
        if (frame) {
          state.frames.value.push(frame);
        }
      })
      .catch((error) => {
        capture_errors.push(error);
        return null;
      });

    pending.push(capture_task);
  }, 170);

  return sampler;
}

function finalize_challenge_capture(pending, capture_errors) {
  return Promise.all(pending).then(() => {
    if (capture_errors.length > 0) {
      throw capture_errors[0];
    }

    return null;
  });
}

function collect_challenge_frames(state, challenge, capture_started_at, capture_frame) {
  const pending = [];
  const capture_errors = [];
  const sampler = create_capture_sampler(
    state,
    challenge,
    capture_started_at,
    capture_frame,
    pending,
    capture_errors
  );
  const wait_for_capture = sleep(challenge.duration_ms);

  return wait_for_capture.then(
    () => {
      window.clearInterval(sampler);
      return finalize_challenge_capture(pending, capture_errors);
    },
    (error) => {
      window.clearInterval(sampler);
      throw error;
    }
  );
}

function run_challenge_at_index(state, challenges, capture_started_at, capture_frame, index) {
  if (index >= challenges.length) {
    return Promise.resolve();
  }

  const challenge = Reflect.get(challenges, index);
  state.challenge_index.value = index;
  state.current_challenge.value = challenge;
  state.status_message.value = challenge.instruction;

  return collect_challenge_frames(state, challenge, capture_started_at, capture_frame).then(() => {
    return run_challenge_at_index(state, challenges, capture_started_at, capture_frame, index + 1);
  });
}

export function capture_challenges(state, capture_frame) {
  const capture_started_at = performance.now();
  const challenges = state.session.value?.challenges || [];
  const capture_flow = run_challenge_at_index(state, challenges, capture_started_at, capture_frame, 0);
  return capture_flow;
}
